import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as availableEmojies from './availableEmojies';

import classes from './Emoji.scss';

export default function Emoji({ code, size, icon }) {
  const iconIndex = code.match(/^:(.+):$/)?.[1];
  const src = availableEmojies[iconIndex] ?? availableEmojies.default;

  let styles = {};

  if (size) {
    styles.width = styles.height = size;
  }

  return (
    <span className={classNames(classes.Emoji, { [classes.icon]: icon })} style={styles}>
      <img src={src} alt={code} />
    </span>
  );
}

Emoji.propTypes = {
  code: PropTypes.string.isRequired,
  size: PropTypes.number,
  icon: PropTypes.bool,
};
